export default __webpack_public_path__ + "locales/it/UploadPanel.json?hash=f4ed053ee6b30cf8a4cded4c667c173c";